/** Nome do módulo exibido no breadcrumb do header (padrão PV/PA: first-level). */
export const MODULE_BREADCRUMB_NAME = 'Módulo Monitor Legislativo';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/radar': 'Radar por cliente',
  '/preferences': 'Preferências',
  '/logs': 'Logs de Envio',
  '/settings': 'Configurações',
};

export function getPageTitleFromPath(pathname: string): string {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
  if (pathname.startsWith('/legislation')) return 'Legislação';
  if (pathname.startsWith('/changes')) return 'Mudanças';
  return 'Legislação';
}
